import React from "react";
import contactImg from "../Assets/contactImg.webp"
import { useFormik } from "formik";
import { signupSchema } from "../Schemas/Index";
const initialValues = {
  name: "",
  email: "",
  subject: "",
  phone: "",
  message: "",
};
export default function CommonContact() {
  const { values, errors, handleChange, handleBlur, handleSubmit, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: signupSchema,
      onSubmit: (values , action) => {
        console.log(values);
        action.resetForm();
      },
    });
  console.log(errors);
  return (
    <>
      <div className="contactSection">
        <div className="contactWrapper">
          <div className="topBlock">
            <h3>CONTACT US</h3>
            <h1>GET IN TOUCH</h1>
          </div>
          <div className="bottomBlock">
            <form action="" onSubmit={handleSubmit}>
              <div className="form-block">
             <div className="form-group">
             <input
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoSave="off"
                  autoCorrect="off"
                  autoComplete="off"
                />
                <p className="form-error">
                  {errors.name && touched.name ? errors.name : null}
                </p>
             </div>

            <div className="form-group">
            <input
                  type="email"
                  placeholder="Your Email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoSave="off"
                  autoCorrect="off"
                  autoComplete="off"
                />
                <p className="form-error">
                  {errors.email && touched.email ? errors.email : null}
                </p>
            </div>
              </div>

              <div className="form-block">
              <div className="form-group">
              <input
                  type="text"
                  placeholder="Subject"
                  name="subject"
                  value={values.subject}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoSave="off"
                  autoCorrect="off"
                  autoComplete="off"
                />
                <p className="form-error">
                  {errors.subject && touched.subject ? errors.subject : null}
                </p>
              </div>

             <div className="form-group">
             <input
                  type="text"
                  placeholder="Phone"
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoSave="off"
                  autoCorrect="off"
                  autoComplete="off"
                />
                <p className="form-error">
                  {errors.phone && touched.phone ? errors.phone : null}
                </p>
             </div>
              </div>
              <div className="form-block textareaBlock">
                <textarea
                  name="message"
                  id=""
                  cols="30"
                  rows="6"
                  placeholder="Your Message"
                  value={values.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  autoSave="off"
                  autoCorrect="off"
                  autoComplete="off"
                ></textarea>
                <p className="form-error">
                  {errors.message && touched.message ? errors.message : null}
                </p>
              </div>
              <button>SEND MESSAGE</button>
            </form>
          </div>

        </div>
        <div className="locationBlock">
            <div className="leftSection">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d87794.29180346213!2d77.17530899932129!3d28.602508572110334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1df6b9055fb5%3A0x81c10b266b1ea3c0!2sIndian%20Institute%20of%20Technology%20Delhi!5e1!3m2!1sen!2sin!4v1690702717252!5m2!1sen!2sin"   allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="iit delhi"></iframe>
            </div>
            <div className="rightSection">
              <figure>
              </figure>
            </div>
          </div>
      </div>
    </>
  );
}
